module.exports = __webpack_public_path__ + "img/shop.b88bcf96.png";